import { render, staticRenderFns } from "./Arm1500.vue?vue&type=template&id=7060e7d4"
import script from "./Arm1500.vue?vue&type=script&lang=js"
export * from "./Arm1500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports